import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const PublicChannelIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' {...props} ref={ref} data-testid='public_channel_icon'>
        <path d='M1.6665 12.5C1.6665 12.5 1.6665 7.5 6.6665 7.5C9.99984 7.5 10.4165 10.4167 12.9165 10.4167C16.2498 10.4167 16.2498 7.5 16.2498 7.5H18.3332C18.3332 7.5 18.3332 12.5 13.3332 12.5C9.99984 12.5 8.74984 9.58333 7.08317 9.58333C3.74984 9.58333 3.74984 12.5 3.74984 12.5H1.6665Z' fill='currentColor' />
    </svg>
));
